import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { BusyService } from './busy.service';

@Injectable({
  providedIn: 'root'
})
export class SessionExpiredService {
  private visibleSubject = new BehaviorSubject<boolean>(false);
  visible$ = this.visibleSubject.asObservable();

  constructor(
    private authService: AuthService,
    private router: Router,
    private busyService: BusyService
  ) {}

  show() {
    if (this.visibleSubject.value || this.router.url === '/login') {
      return;
    }
    this.busyService.forceIdle();
    this.visibleSubject.next(true);
  }

  loginAgain() {
    this.visibleSubject.next(false);
    this.busyService.forceIdle();
    this.authService.clearSession();
    void this.router.navigate(['/login']).then(() => {
      this.busyService.forceIdle();
      if (typeof window !== 'undefined') {
        window.setTimeout(() => this.busyService.forceIdle(), 0);
      }
    });
  }
}
